import * as THREE from "three";
import { useMemo } from "react";
import { useBox } from "@react-three/cannon";
import { THICKNESS, Y, RAIL_HEIGHT, computeRailPoints, computeFullPerimeter } from "./shared";

export default function GlassRailing() {
	const innerPoints = useMemo(() => computeRailPoints(), []);
	const fullPoints = useMemo(() => computeFullPerimeter(), []);

	const tubePoints = useMemo(
		() => fullPoints.map((p) => p.clone().add(new THREE.Vector3(0, THICKNESS + RAIL_HEIGHT, 0))),
		[fullPoints],
	);

	const glassGeo = useMemo(() => {
		const positions: number[] = [];
		const indices: number[] = [];
		const bottom = Y;
		const top = Y + THICKNESS + RAIL_HEIGHT;

		for (let i = 0; i < innerPoints.length - 1; i++) {
			const p1 = innerPoints[i];
			const p2 = innerPoints[i + 1];
			const base = positions.length / 3;
			positions.push(p1.x, bottom, p1.z);
			positions.push(p2.x, bottom, p2.z);
			positions.push(p1.x, top, p1.z);
			positions.push(p2.x, top, p2.z);
			indices.push(base, base + 1, base + 2);
			indices.push(base + 1, base + 3, base + 2);
		}

		const g = new THREE.BufferGeometry();
		g.setAttribute("position", new THREE.Float32BufferAttribute(positions, 3));
		g.setIndex(indices);
		g.computeVertexNormals();
		return g;
	}, [innerPoints]);

	const topTube = useMemo(() => {
		const curve = new THREE.CatmullRomCurve3(tubePoints, false);
		return new THREE.TubeGeometry(curve, 128, 0.05, 8, false);
	}, [tubePoints]);

	return (
		<>
			<mesh geometry={glassGeo} receiveShadow>
				<meshPhysicalMaterial
					color="#004d99"
					transparent
					opacity={0.25}
					roughness={0.05}
					metalness={0.1}
					side={THREE.DoubleSide}
				/>
			</mesh>
			<mesh geometry={topTube} castShadow receiveShadow>
				<meshStandardMaterial color="#853f2d" roughness={0.7} />
			</mesh>
		</>
	);
}
